export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '查询时间',
		align: 'center',
		dataIndex: 'searchTime',
		scopedSlots: { customRender: 'searchTime' },
	},
	{
		title: '查询类型',
		align: 'center',
		dataIndex: 'taskType',
		scopedSlots: { customRender: 'taskType' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
	},
	{
		title: '就诊人姓名',
		align: 'center',
		dataIndex: 'patientName',
		scopedSlots: { customRender: 'patientName' },
	},
	{
		title: '查询人',
		align: 'center',
		dataIndex: 'creatorName',
	},
	{
		title: '查询结果',
		align: 'center',
		dataIndex: 'orderStatus',
		scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '分支公司',
		align: 'center',
		dataIndex: 'companyName',
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
